module.exports = __webpack_public_path__ + "static/media/confetti.73a4e683.svg";